
export function findToolbarElement(toolbarElementArray,index) {

  for (var i=0; i < toolbarElementArray.length; i++) {
    if (toolbarElementArray[i].index == index)
      return (toolbarElementArray[i])
    if (toolbarElementArray[i].submenu != undefined) {
      for (var sub=0; sub < toolbarElementArray[i].submenu.length; sub++)
        if (toolbarElementArray[i].submenu[sub].index == index)
          return (toolbarElementArray[i].submenu[sub])
    }
  }
  return (null)
}

export function setToolbarElementLabel(toolbarElementArray,index,string) {
  var toolbarElement = findToolbarElement(toolbarElementArray,index)
  if (toolbarElement == null)
    return
  toolbarElement.label = string
}

export function setToolbarElementDisabledFlag(toolbarElementArray,index,flag) {
  var toolbarElement = findToolbarElement(toolbarElementArray,index)
  if (toolbarElement == null)
    return
  toolbarElement.disabled = flag
}

// saves the current state of all the toolbar elements and then disables them all  (was used by the 'tour')
export function setAllToolbarElementsDisabled(toolbarElementArray) {
  for (var i=0; i < toolbarElementArray.length; i++) {
    toolbarElementArray[i].saveDisabled = toolbarElementArray[i].disabled
    toolbarElementArray[i].disabled = true

    if (toolbarElementArray[i].submenu != undefined) {
      for (var sub=0; sub < toolbarElementArray[i].submenu.length; sub++) {
        toolbarElementArray[i].submenu[sub].saveDisabled = toolbarElementArray[i].submenu[sub].disabled
        toolbarElementArray[i].submenu[sub].disabled = true 
      }
    }
  }
}

// restores all the toolbar elements disabled flags  (was used by the 'tour')
export function restoreAllToolbarElementsDisabled(toolbarElementArray) {
  for (var i=0; i < toolbarElementArray.length; i++) {
    toolbarElementArray[i].disabled = toolbarElementArray[i].saveDisabled

    if (toolbarElementArray[i].submenu != undefined) {
      for (var sub=0; sub < toolbarElementArray[i].submenu.length; sub++) {
        toolbarElementArray[i].submenu[sub].disabled = toolbarElementArray[i].submenu[sub].saveDisabled
      }
    }
  }
}